export default __webpack_public_path__ + "static/media/about_grandmaster_desc.5e541f38.png";